<template>
  <v-dialog persistent :value="show" :max-width="300">
    <v-card>
      <v-card-title class="font-size-20 blue-grey--text text--darken-3">
        {{ $t('excel.cancel_dialog_title') }}
      </v-card-title>
      <v-card-text>
        <p
          class="font-size-14 ma-0 pa-0 blue-grey--text text--darken-2"
          v-html="$t('excel.cancel_dialog_subtitle')"
        />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn rounded plain text color="blue-grey" @click="$emit('close')">{{
          $t('excel.continue_import')
        }}</v-btn>
        <v-btn rounded plain text color="red" @click="$emit('confirm')">{{
          $t('excel.yes_cancel')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'CancelDialog',

  props: {
    show: Boolean,
    loading: Boolean,
  },
}
</script>
